import { useAuth } from '@/contexts/AuthContext';
import { ClipboardList, Loader2 } from 'lucide-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from './Login';

const Index = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if we have a user and we're not still loading
    if (user && !isLoading) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate, isLoading]);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 mx-auto shadow-lg shadow-purple-500/25">
            <ClipboardList className="w-8 h-8 text-white" />
          </div>
          <div className="space-y-2">
            <Loader2 className="h-6 w-6 animate-spin text-purple-500 mx-auto" />
            <p className="text-lg font-medium text-foreground">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  // Show login page for unauthenticated users
  if (!user) {
    return <Login />;
  }

  // This should not be reached due to the redirect above, but just in case
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="h-6 w-6 animate-spin text-purple-500 mx-auto" />
        <p className="text-muted-foreground">Redirecting to dashboard...</p>
      </div>
    </div>
  );
};

export default Index;
